module.exports = __webpack_public_path__ + "static/media/warningBlack.cefbcd79.svg";